import Chip from "@mui/material/Chip";

const toTitleCase = (s) =>
  String(s ?? "")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());

const statusToColor = (v) => {
  switch (String(v ?? "").toLowerCase()) {
    case "in transit": return "info";
    case "in progress": return "info";
    case "completed": return "success";
    case "delivered": return "success";
    case "delayed": return "error";
    case "cancelled": return "warning";
    default: return "default";
  }
};

export default function StatusChip({ value }) {
  const label = toTitleCase(value) || "—";
  const color = statusToColor(value);

  return <Chip size="small" label={label} color={color} variant="outlined" />;
}
